import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header>
      <div className="d-flex justify-content-between align-items-center p-4">
        <div className="logo simple-check-logo">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/simple-check-logo.png`} alt="logo" />
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
